import React, { createContext, useContext, useState } from 'react';
import ReactDOM from 'react-dom';

import {
    Toast,
    ToastInterface,
    ToastProvider as CoreToastProvider,
    ToastType
} from '@/components/core/Toast';

interface ToastRef {
    info: (text: string) => void;
    error: (text: string) => void;
    success: (text: string) => void;
    warning: (text: string) => void;
}

const ToastContext = createContext<ToastRef | null>(null);

const ToastProvider= ({ children }: React.PropsWithChildren)=> {
    const [toasts, setToasts] = useState<ToastInterface[]>([]);

    const showToast = (text: string, type: ToastType) => {
        setToasts([...toasts, {
            text,
            type,
            id: Date.now().toString()
        }]);
    };

    const showInfoToast = (text: string) => {
        showToast(text, ToastType.INFO);
    };

    const showErrorToast = (text: string) => {
        showToast(text, ToastType.ERROR);
    };

    const showSuccessToast = (text: string) => {
        showToast(text, ToastType.SUCCESS);
    };

    const showWarningToast = (text: string) => {
        showToast(text, ToastType.WARNING);
    };

    const hideToast = (toastId: string) => {
        const updatedToasts = toasts.filter((toast) => toastId !== toast.id);
        setToasts(updatedToasts);
    };

    return (
        <ToastContext.Provider
            value={{
                info: showInfoToast,
                error: showErrorToast,
                success: showSuccessToast,
                warning:showWarningToast,
            }}
        >
            {children}
            {ReactDOM.createPortal(
                <CoreToastProvider>
                    <div className="toast-list">
                        {toasts.map((toast) => <Toast key={toast.id} toast={toast} onClose={() => hideToast(toast.id)} />)}
                    </div>
                </CoreToastProvider>,
                document.body,
            )}
        </ToastContext.Provider>
    );
};

const useToast = () => {
    const context = useContext(ToastContext);
    if (!context) {
        throw new Error('useToast must be used within a ToastProvider');
    }
    return { toast: context };
};

export { ToastProvider, type ToastRef, useToast };
